/**
 * Bottom sheet below 1024 px, dialog from 1024 px — decided on the viewport, in JS: the modal
 * portals to <body>, outside the shell's `@container/humint`, so container queries cannot
 * decide it. The server render and the first paint without `matchMedia` get the sheet.
 */
import { useSyncExternalStore } from 'react'

const DESKTOP_QUERY = '(min-width: 64rem)'

/** One live MediaQueryList for every caller, made on first use (never on the server). */
let desktop: MediaQueryList | null = null

function desktopQuery(): MediaQueryList | null {
  if (!desktop && typeof window !== 'undefined' && window.matchMedia) {
    desktop = window.matchMedia(DESKTOP_QUERY)
  }
  return desktop
}

function subscribe(onChange: () => void): () => void {
  const query = desktopQuery()
  query?.addEventListener('change', onChange)
  return () => query?.removeEventListener('change', onChange)
}

const isDesktop = () => desktopQuery()?.matches ?? false

export function useModalVariant(): 'sheet' | 'dialog' {
  return useSyncExternalStore(subscribe, isDesktop, () => false) ? 'dialog' : 'sheet'
}
